import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBroom = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 19.5,
			y1: 2.5,
			x2: 12.7,
			y2: 9.3
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12.7 9.3l-2.1-.5a3 3 0 0 0-2.8.8l-3.3 3.3a13 13 0 0 0 7.1 7.1l3.3-3.3a3 3 0 0 0 .8-2.8l-.5-2.1z" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 8,
			y1: 14.5,
			x2: 10.5,
			y2: 17
		})
	]
});
export default SvgBroom;
